<template>
  <div id="checkout-cart">
    <div class="shop-cart view">
      <div class="cart-container">
        <Shop />
      </div>
    </div>
    <transition name="slide" mode="out-in">
      <div v-if="!isEmpty()" class="shop-cart view">
        <div class="cart-container">
          <div class="cart-items">
            <div class="cart-item" v-for="item in cart" :key="item.id">
              <div class="product-image">
                <img :src="item.imagemUrl" :alt="item.titulo" />
              </div>

              <div class="flex price-box">
                <div class="product-text">
                  <div class="title">{{ item.titulo }}</div>
                  <div class="price">{{ Number(item.preco) | currency }}</div>
                </div>
                <div class="flex space-between align-items-center">
                  <div class="quantity">
                    <button
                      class="button-quantity minus"
                      @click="
                        umProdutoApenas && item.qty <= 1
                          ? () => {}
                          : reduceQty(item.id)
                      "
                    >
                      <i class="fas fa-minus"></i>
                    </button>

                    <input
                      type="number"
                      pattern="[0-9]*"
                      oninput="this.value =
                    this.value.replace(/\D/g, '')"
                      class="quantity-input"
                      v-model="item.qty"
                    />

                    <button
                      class="button-quantity plus"
                      @click="addQty(item.id)"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="empty-cart" v-if="isEmpty()">
              <div class="cart-item">
                Nenhum produto selecionado...
              </div>
              <div class="cart-animation">
                <lottie-animation
                  path="animations/emptyCartAnimation.json"
                  :loop="true"
                  :autoPlay="true"
                  :height="256"
                />
              </div>
            </div> -->
            <!-- <div class="clear-cart">
              <button class="btn btn-limpar" @click="confirmarLimparCarrinho()">
                <i class="fas fa-trash"></i> Limpar Carrinho
              </button>
            </div> -->
          </div>
          <!-- <div class="cart-description">
            <div class="cart-option">
              <span class="subtotal-description">Subtotal: </span>
              <span class="subtotal-value">{{
                Number(totalPrice) | currency
              }}</span>
            </div>
          </div> -->
          <div class="cart-bottom">
            <div class="price">
              <span class="subtotal-description">Subtotal</span>
              <span class="value">{{ Number(valorTotal) | currency }}</span>
            </div>
            <div class="buy">
              <button
                @click="placeOrder"
                :disabled="valorTotal == 0"
                v-if="cart.length"
              >
                <span>Continuar &nbsp;</span>
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import Shop from "../components/Shop";

export default {
  name: "Cart",
  components: {
    Shop,
  },
  watch: {
    products() {
      if (this.products && this.products.length == 1) {
        this.umProdutoApenas = true;
      }
    },
  },
  props: {
    ambienteProducao: {
      type: Boolean,
      description:
        "Propriedade que define se o ambiente atual de execução é ou não de produção",
      default: false,
    },
  },
  beforeMount() {},
  data() {
    return {
      cartIsOpen: false,
      orderPlaced: false,
      umProdutoApenas: false,
    };
  },
  computed: {
    ...mapGetters([
      "profile",
      "ClientId",
      "CONFIGS",
      "cart",
      "fees",
      "products",
      "cartProductsIDs",
      "cartProductsNames",
      "cartProductsValues",
      "cartProductsQtys",
    ]),
    valorTotal() {
      return this.cart.reduce((a, b) => a + b.qty * b.preco, 0);
    },
  },
  methods: {
    ...mapActions([
      "addFees",
      "removeItemFromCart",
      "addQty",
      "reduceQty",
      "emptyCart",
      "getCartProductID",
      "getCartProductName",
      "getCartProductsValues",
      "getCartProductsQtys",
    ]),

    confirmarLimparCarrinho() {
      this.$swal
        .fire({
          icon: "warning",
          text: "Deseja mesmo limpar o carrinho?",
          showDenyButton: true,
          confirmButtonText: "Limpar",
          denyButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.emptyCart();
            this.$swal.fire({
              icon: "success",
              toast: true,
              position: "bottom-start",
              timer: 1400,
              timerProgressBar: true,
              showConfirmButton: false,
              title: "Carrinho limpo",
            });
          }
        });
    },
    placeOrder() {
      this.isProcessing = true;
      this.isProcessing = false;
      this.cartIsOpen = false;
      this.orderPlaced = true;

      const isInIframe = window.self !== window.top;

      /*this.msgCart(
        "success",
        "Pedido realizado",
        "Você será redirecionado para a página de pagamento em alguns segundos",
        5000
      );*/

      // this.navigateGoBack(-1);
      if (isInIframe) {
        window.top.postMessage(
          {
            action: "redirect",
            url: this.mountOrderUrl(),
          },
          "*"
        );
      } else {
        window.location.href = this.mountOrderUrl();
      }
      // window.open(`${this.mountOrderUrl()}`, "_blank");
    },
    mountOrderUrl() {
      // [] nomeCliente=Diogo Ferreira Teste NSC&cpfCliente=39898143380&dataNascCliente=12-04-2003
      // [] &pedidoEmail=diogo.santos@nscinfo.com.br&pedidoPhone=19991621576
      // [] &enderecoCep=13972184&enderecoBairro=Jardim Isaura&enderecoCidade=Itapira&enderecoEstado=SP&enderecoNumero=511&enderecoRua=Rua Imperatriz Leopoldina

      // [X] &produtosNome=Produto teste 1 %3B Produto teste 2%3BProduto teste 3%3BProduto teste 4%3BProduto teste 5%3BProduto teste 6
      // [X] &produtosValor=2.89%3B4.82%3B3.55%3B4.56%3B6.54%3B5.64
      // [X] &produtosQtde=3 %3B 1 %3B 5 %3B 4%3B2%3B10
      // [X] &vendedorId=2f671c3ea2ec452083f19a3322a4ba5b
      // [X] &pedidoId=54876
      // [X] &taxas=10
      // [X] &clientID=id_da_configuração_utilizada_no_embed

      // Iniciando a filtragem de todos os nomes dos produtos
      this.getCartProductID();
      // Invocando a filtragem de todos os nomes dos produtos
      this.getCartProductName();
      // Invocando a filtragem de todos os preços dos produtos
      this.getCartProductsValues();
      // Invocando a filtragem de todas as quantidades dos produtos
      this.getCartProductsQtys();

      let host = this.ambienteProducao
        ? "https://checkout.nscpay.com.br/"
        : "https://testecheckout.nscpay.com.br/";
      // : "http://127.0.0.1:5173/";

      let url = `${host}?clientID=${this.ClientId}&produtosID=${
        this.cartProductsIDs
      }&produtosNome=${this.cartProductsNames}&produtosValor=${
        this.cartProductsValues
      }&produtosQtde=${this.cartProductsQtys}&taxas=${
        this.fees
      }&configuracaoID=${this.CONFIGS.id}&pedidoId=${uuidv4()}`;

      // this.emptyCart();

      if (Object.keys(this.profile).length > 1 && this.profile.clientID) {
        url = `${url}&enderecoBairro=${this.profile.enderecoBairro}&enderecoCep=${this.profile.enderecoCep}&enderecoCidade=${this.profile.enderecoCidade}&enderecoEstado=${this.profile.enderecoEstado}&enderecoNumero=${this.profile.enderecoNumero}&enderecoRua=${this.profile.enderecoRua}&cpfCliente=${this.profile.cpfCliente}&dataNascCliente=${this.profile.dataNascCliente}&nomeCliente=${this.profile.nomeCliente}&clienteEmail=${this.profile.clienteEmail}&clienteTelefone=${this.profile.clienteTelefone}`;
        if (this.profile.referencia) {
          url = url.concat(`&referencia=${this.profile.referencia}`);
        }
      }

      console.log("@@@ Redirecionamento:", url);

      return url;
    },
    isEmpty() {
      return this.cart.length < 1 ? true : false;
    },
    msgCart(type, title, text) {
      this.$swal.fire({
        icon: type,
        title: title,
        text: text,
      });
    },
    navigateTo(name) {
      this.$router.push({ name });
    },
    navigateGoBack(back) {
      this.$router.go(back);
    },
    getCurrentRoute() {
      return this.$route.name;
    },
  },
};
</script>
